export default __webpack_public_path__ + "pgnv-assets/1274c5cfcf2f4866ec364813e11c7a6b.png";